<template>
  <section class="choice">
    <span class="choice__title semibold" v-html="'hai selezionato:'" />
    <div class="choice__alert" v-if="!check_availability(solution.rooms, solution.checkout_payload.occupancy)">
      <div class="choice__alert-message">
        <vb-icon class="choice__alert-icon" :name="'info'" :color="'d4111e'" :size="16" />
        <div class="choice__alert-text">
          <span v-html="'Attenzione! La tua scelta non è adatta alla ricerca che hai effettuato.'" />
          <span v-html="'Se decidi di procedere ugualmente potrebbero essere richiesti supplementi al momento dell’arrivo in hotel.'" />
          <router-link class="choice__alert-modify" :to="{name: 'detail'}" v-html="'modifica la tua scelta'" />
        </div>
      </div>
    </div>

    <card-recap class="choice__recap" :solution="solution" />
  </section>
</template>

<script>
import { add, subtract, sum, multiply } from 'mathjs'
import CardRecap from "@booking/components/blocks/card-recap.vue"

export default {
  name: 'choice',

  components: {
    'card-recap': CardRecap,
  },

  props: {
    solution: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {

    check_availability(rooms, occupancy) {


      let total_rooms_occupancy = 0,
          total_children_free = 0,
          rooms_paying = 0,

          total_occupancy = 0,
          occupancy_paying = 0


      for (const room of occupancy) {
        // calcolo la quantità totale della mia occupancy
        total_occupancy += room.adults + room.children.length

        // calcolo la quantità totale di persone paganti della mia occupancy (gli adulti)
        occupancy_paying += room.adults
      }

      for (const name in rooms) {
        for (const block in rooms[name].blocks) {
          const { max_adults, max_children_free, max_occupancy, incremental_price_selected } = rooms[name].blocks[block]
          const quantity = incremental_price_selected.quantity

          // calcolo la quantità totale di persone che le camere possono ospitare
          total_rooms_occupancy = add(total_rooms_occupancy, sum(multiply(max_adults, quantity), multiply(max_children_free, quantity)))

          // se max_adults e max_occupancy sono uguali, sottraggo 1 da total_rooms_occupancy, condizione legata all'icona
          // del bambino che non viene mostrata quando max_adults e max_occupancy sono uguali
          if(max_adults === max_occupancy) total_rooms_occupancy = subtract(total_rooms_occupancy, 1)

          // calcolo la quantità totale di bambini gratis che le camere possono ospitare
          total_children_free = add(total_children_free, multiply(max_children_free, quantity))

          // calcolo la quantità totale di persone paganti (gli adulti)
          rooms_paying = add(rooms_paying, multiply(max_adults,quantity))
        }
      }

      // per ogni bambino presente in occupancy, cerco una corrispondenza in un blocco basata sulla disponibilità (total_children_free)
      // se non trovo una corrispondenza, viene incrementato il contatore occupancy_paying
      for (const current_occupancy of occupancy) {
        for (const current_child_age of current_occupancy.children) {
          let match_found = false

          for (const current_room of rooms) {
            for (const block_key in current_room.blocks) {
              const block = current_room.blocks[block_key]

              if ((total_children_free > 0) && (current_child_age <= block.max_children_free_age)) {
                match_found = true
                total_children_free = subtract(total_children_free, 1)
                break
              }
            }

            if (match_found) {
              break
            }
          }

          if (!match_found) {
            occupancy_paying = add(occupancy_paying, 1)
          }
        }
      }

      return (total_rooms_occupancy >= total_occupancy) && (rooms_paying >= occupancy_paying)
    }

  },
}
</script>

<style lang="scss" scoped>

  .choice {
    @extend %section;

    &__alert {
      display: flex;
      align-items: flex-start;
      margin-top: 5px;
      flex-wrap: wrap;

      &-message {
        display: flex;
      }

      &-icon {
        margin-top: 5px;
        margin-right: 8px;
      }

      &-text {
        color: $danger;

        span {

          &:first-child {
            font-size: $font-size-lg;
            font-weight: $vb-font-weight-semibold;
            margin-right: 6px;
            display: block;

            @include media-breakpoint-up(xxl) {
              display: inline-block;
            }
          }

          &:nth-child(2) {
            display: inline-block;
            margin-right: 20px;
          }
        }
      }

      &-modify {
        color: $info;
        font-size: $font-size-md;
        text-decoration: underline;
        margin-top: 5px;
        font-weight: $font-weight-base;
      }
    }

    &__recap {
      margin-top: 20px;
    }

    ::v-deep {
      .recap__header, .recap__price {
        display: none;
      }
    }
  }

</style>